import Cookies from 'js-cookie'
import moment from 'moment'
import { isPC } from './device'
import { ybiConfig } from './ybiConfig'

export class YbiService {
  constructor() {
    this.ybiConfig = null
    this.td = null
    this.userSlug = ''
    this.userDeviceType = ''
    this.timer = null

    this.ybiConfig = ybiConfig
    this.initialize()
  }

  initialize() {
    this.td = new Treasure({
      // debug項目 ↓↓↓↓↓↓↓↓↓↓↓
      //development: true,
      //logging: true,
      // debug項目 ↑↑↑↑↑↑↑↑↑↑↑
      host: 'in.treasuredata.com',
      writeKey: this.ybiConfig.apiKey,
      database: this.ybiConfig.database
    })
    this.userSlug = Cookies.get('user_slug')
    if (isPC) {
      this.userDeviceType = 'p'
    } else {
      this.userDeviceType = 's'
    }
  }

  postPlayMovie(program) {
    let isLive = 0
    if (program.is_live) {
      isLive = 1
    }
    let isReAir = 0
    if (program.re_air) {
      isReAir = 1
    }
    // console.log('send movie', program)
    this.td.addRecord(
      this.ybiConfig.tablePlayMovie,
      {
        programinfo_title: program.title,
        programinfo_slug: program.slug,
        user_slug: this.userSlug,
        user_device_type: this.userDeviceType,
        enviroment: this.ybiConfig.enviroment,
        programinfo_is_live: isLive,
        programinfo_re_air: isReAir,
        programinfo_livegroup: program.live_group,
        movie_type: '',
        transcode_slug: '',
        programinfo_startdatetime: moment(program.start_datetime)
          .utc()
          .format('YYYY-MM-DD HH:mm:ss'),
        programinfo_enddatetime: moment(program.end_datetime)
          .utc()
          .format('YYYY-MM-DD HH:mm:ss')
      },
      this._successCallback,
      this._errorCallback
    )
  }

  postPlayVod(programinfoSlug, title, isLive, startDatetime, endDatetime, isVod, vodPublishStartDatetime, vodPublishEndDatetime, referrer) {
    let isProgramLive = 0
    if (isLive) {
      isProgramLive = 1
    }
    let isProgramVod = 0
    if (isVod) {
      isProgramVod = 1
    }
    let fixedProgramStartDatetime = ''
    if (startDatetime != null) {
      fixedProgramStartDatetime = moment(startDatetime)
        .utc()
        .format('YYYY-MM-DD HH:mm:ss')
    }
    let fixedProgramEndDatetime = ''
    if (endDatetime != null) {
      fixedProgramEndDatetime = moment(endDatetime)
        .utc()
        .format('YYYY-MM-DD HH:mm:ss')
    }
    let fixedVodStartDatetime = ''
    if (vodPublishStartDatetime != null) {
      fixedVodStartDatetime = moment(vodPublishStartDatetime)
        .utc()
        .format('YYYY-MM-DD HH:mm:ss')
    }
    let fixedVodEndDatetime = ''
    if (vodPublishEndDatetime != null) {
      fixedVodEndDatetime = moment(vodPublishEndDatetime)
        .utc()
        .format('YYYY-MM-DD HH:mm:ss')
    }

    // console.log(referrer)

    this.td.addRecord(
      this.ybiConfig.tablePlayVod,
      {
        programinfo_title: title,
        programinfo_slug: programinfoSlug,
        user_slug: this.userSlug,
        user_device_type: this.userDeviceType,
        enviroment: this.ybiConfig.enviroment,
        programinfo_is_live: isProgramLive,
        programinfo_is_vod: isProgramVod,
        programinfo_startdatetime: fixedProgramStartDatetime,
        programinfo_enddatetime: fixedProgramEndDatetime,
        programinfo_public_startdatetime: fixedVodStartDatetime,
        programinfo_public_enddatetime: fixedVodEndDatetime,
        referrer
        // programinfo_livegroup: program.live_group,
        // programinfo_re_air: isReAir,
        // movie_type: '',
        // transcode_slug: '',
      },
      this._successCallback
    )
  }

  postDataBloadcast(program) {
    // console.log(program)

    this.td.addRecord(this.ybiConfig.tableDataBloadcast, {
      user_slug: this.userSlug,
      user_device_type: this.userDeviceType,
      programinfo_slug: program.slug,
      programinfo_title: program.title,
      data_broadcast_id: program.id,
      data_broadcast_duration: program.duration,
      data_broadcast_start_timestamp: typeof program.start_timestamp === 'number' ? program.start_timestamp : null,
      data_broadcast_start_after_seconds: typeof program.start_after_seconds === 'number' ? program.start_after_seconds : null,
      data_broadcast_image_url: program.image_url,
      data_broadcast_link_url: program.link_url,
      data_broadcast_is_browser: program.is_browser ? 1 : 0,
      program_type: program.program_type,
      event_type: program.event_type,
      event_start_at: moment().valueOf()
    })
  }

  postPlayAd(adInfo) {
    // console.log({
    //   user_slug: this.userSlug,
    //   user_device_type: this.userDeviceType,
    //   programinfo_slug: adInfo.slug,
    //   programinfo_title: adInfo.title,
    //   ads_id: adInfo.id,
    //   ads_title: adInfo.ads_title,
    //   ads_type: adInfo.ads_type,
    //   ads_duration: adInfo.ads_duration,
    //   ads_start_after_seconds: adInfo.ads_start_after_seconds,
    //   ads_video_url: adInfo.ads_video_url,
    //   ads_link_url: adInfo.ads_link_url,
    //   ads_is_browser: adInfo.ads_is_browser,
    //   event_type: adInfo.event_type,
    //   event_start_at: moment().valueOf()
    // })

    this.td.addRecord(this.ybiConfig.tablePlayAd, {
      user_slug: this.userSlug,
      user_device_type: this.userDeviceType,
      programinfo_slug: adInfo.slug,
      programinfo_title: adInfo.title,
      ads_id: adInfo.id,
      ads_title: adInfo.ads_title,
      ads_type: adInfo.ads_type,
      ads_duration: adInfo.ads_duration,
      ads_start_after_seconds: adInfo.ads_start_after_seconds,
      ads_video_url: adInfo.ads_video_url,
      ads_link_url: adInfo.ads_link_url,
      ads_is_browser: adInfo.ads_is_browser,
      event_type: adInfo.event_type,
      event_start_at: moment().valueOf()
    })
  }

  clearTimer() {
    if (!this.timer) {
      return
    }
    clearInterval(this.timer)
    this.timer = null
  }

  _successCallback() {
    // console.log("## td-js-send success");
  }

  _errorCallback() {
    // console.log("## td-js-send faild. next step call to zap api");
    // TODO: 失敗した場合は、既存のapiを呼び出せるようにする
    // this._sendLog(program.slug);
  }

  _sendLog(slug) {
    // const params = {
    //   programinfo_slug: slug,
    //   transcode_slug: '',
    //   movie_type: ''
    // };
    // this.LogService.post(params).then((response) => console.log('Sending Log', params));
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/VideoPlayer/utils/ybiService.js